import styled from 'styled-components'
import { Typography } from '@telavita-core/react-design-kit'

export const Container = styled.div`
  padding: 10px 4px 5px;

  > div:not(:last-child) {
    margin-bottom: 40px;
  }
`

export const DescriptionText = styled(Typography)`
  margin: 20px 0;
`